export const sanitizePriorCompareCells = (cells = []) => (Array.isArray(cells) ? cells : String(cells || '').split(','))
  .map(item => String(item || '').trim())
  .filter(item => /^[A-Za-z0-9]+:\d{4}$/.test(item))
  .slice(0, 20);

export const buildPriorCompareSearchParams = (compare = {}) => {
  const params = new URLSearchParams();
  if (compare.label) params.set('compareLabel', compare.label);
  if (compare.bucket) params.set('compareBucket', compare.bucket);
  if (compare.identity) params.set('compareIdentity', compare.identity);
  if (compare.index) params.set('compareIndex', String(compare.index));
  if (compare.total) params.set('compareTotal', String(compare.total));
  const cells = sanitizePriorCompareCells(compare.cells || []);
  if (cells.length) params.set('compareCells', cells.join(','));
  return params;
};

export const buildPriorCompareStudyUrl = (studyInstanceUID, compare = {}) => {
  const params = buildPriorCompareSearchParams(compare);
  const suffix = params.toString() ? `?${params.toString()}` : '';
  return `/study/${studyInstanceUID}${suffix}`;
};

export const parsePriorCompareContext = (search = '') => {
  const params = new URLSearchParams(search || '');
  const label = params.get('compareLabel');
  if (!label) return null;
  return {
    label,
    bucket: params.get('compareBucket') || '',
    identity: params.get('compareIdentity') || '',
    index: params.get('compareIndex') || '',
    total: params.get('compareTotal') || '',
    cells: sanitizePriorCompareCells(params.get('compareCells') || ''),
    source: 'prior-compare',
  };
};
